var ENTER_KEYCODE = 13;
var ESCAPE_KEYCODE = 27;

jQuery(function () {
  if ($.fn.flexslider == "function") {
    jQuery(".flexslider").flexslider({
      animation: "slide",
    });
  }

  // Search Bar
  jQuery("#search").on("keypress click", function (e) {
    if (e.type === "keypress" && e.which !== ENTER_KEYCODE) {
      return;
    }
    jQuery(".search-container").fadeIn(400);
    jQuery("#site-search").val("").focus();
    jQuery("#ss-results").empty();
    jQuery("#m-results").empty();
  });
  jQuery("#cancel, .accessory-close, .sc-close, #tips-country-popup .close").on(
    "keypress click",
    function (e) {
      if (e.type === "keypress" && e.which !== ENTER_KEYCODE) {
        return;
      }

      if (e.type === "click") {
        event.preventDefault();
      }

      if ($(this).attr("id") == "cancel") {
        jQuery(".search-container").fadeOut(400);
      } else if ($(this).attr("class").indexOf("accessory-close") != -1) {
        jQuery(".accessories-modal").removeClass("active").fadeOut(300);
        $(".accessories-modal .accessory-popup").hide();
      } else if ($(this).attr("class").indexOf("sc-close") != -1) {
        jQuery(".sc-modal").removeClass("active").fadeOut(300);
        $(".sc-modal .sc-popup").hide();
      } else if ($(this).attr("class").indexOf("close") != -1) {
        $(this).parent().parent().css({ display: "none" });
      }

      $("html, body").css("overflowY", "visible");
    },
  );

  // Form modal
  jQuery(
    ".form-modal, .form-close, .form-modal .hide, .form-open, .modal-container",
  ).on("keypress click", function (e) {
    if (e.type === "keypress" && e.which !== ENTER_KEYCODE) {
      return;
    }

    if ($(this).attr("class").indexOf("form-open") != -1) {
      var dname = $(this).attr("data-name");
      jQuery("." + dname).removeClass("hide");
      jQuery(".modal").addClass("active");
      $("body").addClass("modal-open");
      $(".modal-container").removeClass("hide");
    } else if ($(this).attr("class").indexOf("form-close") != -1) {
      var dname = $(this).attr("data-name");
      $(".form-modal").addClass("hide");
      jQuery(".modal").removeClass("active");
      $("body").removeClass("modal-open");
    }
  });

  //region selector
  var countryDialogTrigger = document.getElementById("country-open");
  var countryDialog = document.getElementById("country-dialog");
  var countryClose = document.getElementById("country-close");

  if (countryDialogTrigger) {
    document
      .getElementById("country-open")
      .addEventListener("keydown", function (event) {
        if (event.key === "Enter") {
          countryDialog.showModal();
        }
      });
    countryDialogTrigger.addEventListener("click", function () {
      countryDialog.showModal();
    });
    countryClose.addEventListener("click", function (event) {
      event.preventDefault();
      countryDialog.close();
    });
  }

  // NOTE: Delete this later
  // jQuery(".overlay, .country-modal, .country-popup, .country-close, .country-modal .hide, .country-open, .modal-container").on('keypress click', function(e) {
  //   if (e.type === 'keypress' && e.which !== ENTER_KEYCODE) {
  //       return;
  //   }
  // 	// if ($(this).attr('class').indexOf('country-open') != -1) {
  // 	// 	jQuery(".country-modal").removeClass('hide')
  // 	// 	jQuery(".modal").addClass('active')
  // 	// 	$(".overlay").css({'display': 'block'});
  // 	// 	// $("body").addClass("modal-open");
  // 	// 	$(".modal-container").removeClass('hide')
  // 	// } else if ($(this).attr('class').indexOf('country-close') != -1) {
  // 	// 	$(".country-modal").addClass('hide');
  // 	// 	$(".country-popup").css({'display': 'none'});
  // 	// 	$(".overlay").css({'display': 'none'});
  // 	// 	jQuery(".modal").removeClass('active')
  // 	// 	// $("body").removeClass("modal-open");
  // 	// }
  // })

  //online-access
  jQuery(
    ".overlay, .online-access-modal, .online-access-popup, .online-access-close, .hide, .online-access-open, .modal-container",
  ).on("keypress click", function (e) {
    if (e.type === "keypress" && e.which !== ENTER_KEYCODE) {
      return;
    }
    if ($(this).attr("class").indexOf("online-access-open") != -1) {
      jQuery(".online-access-modal").removeClass("hide");
      jQuery(".modal").addClass("active");
      $(".overlay").css({ display: "block" });
      // $("body").addClass("modal-open");
      $(".modal-container").removeClass("hide");
    } else if ($(this).attr("class").indexOf("online-access-close") != -1) {
      $(".online-access-modal").addClass("hide");
      $(".online-access-popup").css({ display: "none" });
      $(".overlay").css({ display: "none" });
      jQuery(".modal").removeClass("active");
      // $("body").removeClass("modal-open");
    }
  });

  jQuery(".hover-country").hover(function (event) {
    // var dname = $(this).attr('data-country');
    var dmap = $(this).attr("data-map");
    $("#map").attr("src", dmap);
  });

  jQuery(".hover-country").hover(function (event) {
    // var dname = $(this).attr('data-country');
    var dmap = $(this).attr("data-map");
    $("#pop-map").attr("src", dmap);
  });

  jQuery(window).on("keypress click", function (e) {
    if (e.type === "keypress" && e.which !== ENTER_KEYCODE) {
      return;
    }
    var ev = e.target;
    if ($(ev).attr("class") == "search-container") {
      jQuery(".search-container").fadeOut(400);
      $("html, body").css("overflowY", "visible");
    }

    if (
      $(ev).attr("class") &&
      $(ev).attr("class").indexOf("accessories-modal") > -1
    ) {
      jQuery(".accessories-modal").removeClass("active").fadeOut(300);
      $(".accessories-modal .accessory-popup").hide();
      $("html, body").css("overflowY", "visible");
    }
  });

  //product page stericenter popovers
  jQuery(".ellipse-1,.ellipse-2,.ellipse-3,.ellipse-4,.ellipse-5").on(
    "click",
    function (event) {
      event.stopPropagation();

      jQuery(".popover").not($(this).find(".popover")).hide();

      $(this).find(".popover").toggle();
      $(this).find(".filled-ellipse-rotate").toggle();
      $(this).find(".filled-ellipse").toggle();
    },
  );

  jQuery(".ellipse-1,.ellipse-2,.ellipse-3,.ellipse-4,.ellipse-5").hover(
    function (event) {
      $(this).find(".ellipse").toggle();
      $(this).find(".filled-ellipse").toggle();
    },
  );

  jQuery(document).on("click", function () {
    jQuery(".popover").hide();
    jQuery(".filled-ellipse-rotate").hide();
    jQuery(".filled-ellipse").hide();
    jQuery(".ellipse").show();
  });

  // jQuery('#languageSelector > li').on('click', function() {
  // 	 jQuery(this).toggleClass('open').toggleClass('close');
  //  });

  jQuery(".hamburglar").on("keypress click", function (e) {
    if (e.type === "keypress" && e.which !== ENTER_KEYCODE) {
      return;
    }
    var elem = $(this);
    jQuery({ deg: 0 }).animate(
      {
        deg: 90,
      },
      {
        duration: 500,
        step: function (now, fx) {
          elem.css({
            transform: "rotate(" + now + "deg)",
          });
        },
        complete: function () {
          var curcl = elem.attr("class");
          elem.toggleClass("sc-bars").toggleClass("sc-times");
          if (curcl.indexOf("sc-times") > -1) {
            elem.css({
              transform: "rotate(0deg)",
            });
          }
        },
        done: function () {
          //console.log('done');
        },
      },
    );

    jQuery(".menus").toggleClass("open").toggleClass("close");
    jQuery("header").toggleClass("full-screen");
    jQuery("#mobile-search").val("");
    jQuery("#m-results").empty();
    //jQuery(this).toggleClass('fa-bars').toggleClass('fa-times');
    // jQuery('.menus').toggleClass('open').toggleClass('close');
    // jQuery('header').toggleClass('full-screen');
  });

  // mobile nav
  // open
  jQuery("#open").on("keypress click", function (e) {
    if (e.type === "keypress" && e.which !== ENTER_KEYCODE) {
      return;
    }
    jQuery("#mobileNav").show();
    jQuery("#open").hide();
    jQuery("#close").css({ display: "flex" });
    jQuery("#languageSubMobile").hide();
    jQuery("#openFlagMobile").show();
    jQuery("#closeFlagMobile").hide();
  });
  // close
  jQuery("#close").on("keypress click", function (e) {
    if (e.type === "keypress" && e.which !== ENTER_KEYCODE) {
      return;
    }
    jQuery("#mobileNav").hide();
    jQuery("#open").css({ display: "flex" });
    jQuery("#close").hide();
  });

  jQuery(".main-navgiation > ul > li").each(function (index, ele) {
    //jQuery(ele).append('<span class="openCloseSubMenu">&#43;</span>');
  });

  jQuery(".main-navgiation > ul > li > span.openCloseSubMenu").each(
    function (index, ele) {
      jQuery(ele).on("keypress click", function (e) {
        if (e.type === "keypress" && e.which !== ENTER_KEYCODE) {
          return;
        }
        jQuery(this).parent("li").toggleClass("active");
        if (jQuery(this).parent("li").hasClass("active")) {
          jQuery(this)
            .parent("li")
            .find(".openCloseSubMenu")
            .removeClass("open close")
            .addClass("open");
        } else {
          jQuery(this)
            .parent("li")
            .find(".openCloseSubMenu")
            .removeClass("open close")
            .addClass("close");
        }
      });
    },
  );

  jQuery("footer .container .footer-menu h3").each(function (index, ele) {
    jQuery(ele).on("keypress click", function (e) {
      if (e.type === "keypress" && e.which !== ENTER_KEYCODE) {
        return;
      }
      jQuery(this).parent(".footer-menu").toggleClass("active");
      if (jQuery(this).parent(".footer-menu").hasClass("active")) {
        jQuery(this)
          .parent(".footer-menu")
          .find(".openCloseSubMenu")
          .html("&times;");
      } else {
        jQuery(this)
          .parent(".footer-menu")
          .find(".openCloseSubMenu")
          .html("&#43;");
      }
    });
  });

  jQuery('a[href*="#"]:not([href="#"])').on("keypress click", function (e) {
    if (e.type === "keypress" && e.which !== ENTER_KEYCODE) {
      return;
    }
    if (
      location.pathname.replace(/^\//, "") ==
        this.pathname.replace(/^\//, "") &&
      location.hostname == this.hostname
    ) {
      var target = jQuery(this.hash);
      target = target.length
        ? target
        : jQuery("[name=" + this.hash.slice(1) + "]");
      if (target.length) {
        jQuery("html, body").animate(
          {
            scrollTop: target.offset().top - 150,
          },
          2000,
        );
        return false;
      }
    }
  });
});
jQuery(document).scroll(function () {
  var y = jQuery(this).scrollTop();
  if (y > 500) {
    jQuery(".cd-top").fadeIn();
  } else {
    jQuery(".cd-top").fadeOut();
  }
});

/*****************************
 ********* Main Nav ***********
 *****************************/

/*var $menuItemLinks = jQuery('.menu-item > a');
$menuItemLinks.each(function(index, ele){
	var menuItemUrl = jQuery(ele).attr('href');

	// Disble Accessories links & add custom class
	if ( menuItemUrl == '#accessories-link' ) {
		jQuery(ele).on('click', function(event){
			event.preventDefault();
		});
		jQuery(ele).addClass('accessoriesAnchor');
		jQuery(ele).attr('href','#');
		jQuery(ele).parent().addClass('accessoriesLi');

	}
});

var menuItemTextAddClass = jQuery('.menu-item a');

menuItemTextAddClass.each(function(){
	if (jQuery(this).text() == 'Maintenance' || jQuery(this).text() == 'Autoclave Accessories' || jQuery(this).text() == 'Wasseraufbereitung' || jQuery(this).text() == 'Pflegegeräte') {
		jQuery(this).addClass('maintenanceAnchor');
	}
});*/

/* Video Container */
var videoPlayButton = jQuery(
  ".video-container .play-button, .media-wrapper.play-video, .feature-image.sc-video > div, .pg-home .feature-description .play-link, .lang-video-wrapper.play-video",
);
var videoLightboxClose = jQuery(".video-lightbox .fa-times");
var videoLightbox = jQuery(".video-lightbox");
var videoOpen = false;

var extendSrc = "?enablejsapi=1&amp;version=3&amp;playerapiid=ytplayer";
$(document).keydown(function (e) {
  if (e.keyCode === ESCAPE_KEYCODE) {
    //close video container
    jQuery(this).find(".video-lightbox").css({ display: "none" });
    videoOpen = false;

    //close online access modal
    $(".online-access-modal").addClass("hide");
    $(".online-access-popup").css({ display: "none" });
    $(".overlay").css({ display: "none" });
    $(".optim-video-container .video-play").hide();
    jQuery(".modal").removeClass("active");

    //close accesssory modal
    jQuery(".accessories-modal").removeClass("active").fadeOut(300);
    $(".accessories-modal .accessory-popup").hide();
    $("html, body").css("overflowY", "visible");

    //close search bar
    jQuery(".search-container").fadeOut(400);

    //close products menu
    jQuery("#menu-main-navigation > .menu-item-has-children").removeClass(
      "menu-item-hovered",
    );

    //close jotform
    jQuery(".form-modal").addClass("hide");
    jQuery(".modal").removeClass("active");
    jQuery("body").removeClass("modal-open");
  }
});

jQuery(
  ".video-container, .media-wrapper.play-video, .feature-image.sc-video > div, .play-link, .lang-video-wrapper.play-video",
).on("keypress click", function (e) {
  if (e.type === "keypress" && e.which !== ENTER_KEYCODE) {
    return;
  }
  var videoFrame = document.getElementsByClassName("video")[0];

  if (videoFrame && videoOpen && !videoFrame.contains(e.target)) {
    e.stopPropagation();
    $(".video-lightbox").css({ display: "none" });
    videoOpen = false;
    if (
      jQuery(this).parent().find(".video iframe") &&
      jQuery(this).parent().find(".video iframe").length > 0
    ) {
      ogSource = jQuery(this).parent().find(".video iframe").attr("src");
      jQuery(this)
        .parent()
        .find(".video iframe")
        .attr("src", ogSource + extendSrc);
      jQuery(this)
        .parent()
        .find(".video iframe")[0]
        .contentWindow.postMessage(
          '{"event":"command","func":"' + "stopVideo" + '","args":""}',
          "*",
        );
    } else if (
      jQuery(this).parent().find(".video video") &&
      jQuery(this).parent().find(".video video").length > 0
    ) {
      ogSource = jQuery(this).parent().find(".video video source").attr("src");

      jQuery(this)
        .parent()
        .find(".video video source")
        .attr("src", ogSource + extendSrc);
      jQuery(this).parent().find(".video video")[0].pause();
    }

    e.stopPropagation();
    return;
  }

  if ($(this).attr("class").indexOf("play-link") > -1) {
    $(this)
      .closest(".feature-content")
      .find(".video-lightbox")
      .css({ display: "flex" });
    videoOpen = true;
  } else {
    jQuery(this).find(".video-lightbox").css({ display: "flex" });
    videoOpen = true;
  }

  var videl = $(this).find("iframe")[0];
  if (typeof videl == "undefined" || videl.length == 0) {
    videl = $(this).find("video source")[0];
  }

  sc_methods.removeLazyLoad(videl);

  e.stopPropagation();
});

videoLightboxClose.click(function (e) {
  videoOpen = false;
  jQuery(this).parent().css({ display: "none" });
  e.stopPropagation();
  var ogSource = "";
  var elem;

  if (
    jQuery(this).parent().find(".video iframe") &&
    jQuery(this).parent().find(".video iframe").length > 0
  ) {
    ogSource = jQuery(this).parent().find(".video iframe").attr("src");
    jQuery(this)
      .parent()
      .find(".video iframe")
      .attr("src", ogSource + extendSrc);
    jQuery(this)
      .parent()
      .find(".video iframe")[0]
      .contentWindow.postMessage(
        '{"event":"command","func":"' + "stopVideo" + '","args":""}',
        "*",
      );
  } else if (
    jQuery(this).parent().find(".video video") &&
    jQuery(this).parent().find(".video video").length > 0
  ) {
    ogSource = jQuery(this).parent().find(".video video source").attr("src");

    jQuery(this)
      .parent()
      .find(".video video source")
      .attr("src", ogSource + extendSrc);
    jQuery(this).parent().find(".video video")[0].pause();
  }

  e.stopPropagation();
});

/**
 * Site search using lunrjs Search
 *
 */
var lunrIndex, $results, searchIndex;

// Initialize lunrjs using the search index file
function initLunr() {
  // First retrieve the index file. /js/PagesIndex.json
  if (typeof scBaseURL == "undefined") {
    scBaseURL = "/";
  }
  jQuery
    .getJSON(scBaseURL + "search-index.json?r=" + rev)
    .done(function (index) {
      searchIndex = index;
      // set up fields to be searched.
      lunrIndex = lunr(function () {
        //add language Support
        var lang = document
          .getElementsByTagName("html")[0]
          .getAttribute("lang");
        var ext = lang.substring(0, 2).toLowerCase();

        if (ext !== "en") {
          if (ext == "de") {
            this.use(lunr.de);
          } else if (ext == "ja") {
            this.use(lunr.ja);
          }
        }

        this.field("title", {
          boost: 15,
        });
        this.field("tags", {
          boost: 10,
        });
        this.field("description", { boost: 5 });
        this.field("content");

        // set link for ref
        this.ref("ref");

        searchIndex.forEach(function (page) {
          this.add(page);
        }, this);
      });
    })
    .fail(function (jqxhr, textStatus, error) {
      var err = textStatus + ", " + error;
      console.error("Error getting Hugo index file:", err);
    });
}

// initialize search input
/**
 * initialize search
 * @param  {String} sid 	search input id
 * @param  {String} rid   result element id
 */
function initSearch(sid, rid) {
  $results = jQuery("#" + rid);
  jQuery("#" + sid).keyup(function () {
    $results.empty();

    // trigger search when there are 2 or more characters
    var query = jQuery(this).val();
    if (query.length < 2) {
      return;
    }

    var res = search(query);

    renderResults(res, rid);
  });
  jQuery("#" + sid).keydown(function () {});
}

/**
 * Carry out lunar search
 *
 * @param  {String} query search term
 * @return {Array}  result search result
 */
function search(query) {
  // find matches by comparing lunr ref with search index ref
  //var res = lunrIndex.search(query);
  var q = decodeURIComponent(query);
  return lunrIndex.search(q).map(function (result) {
    return searchIndex.filter(function (page) {
      return page.ref === result.ref;
    })[0];
  });
}

function renderResults(results, rid) {
  if (!results.length) {
    jQuery("#" + rid)
      .parent()
      .hide();
    return;
  }

  jQuery("#" + rid).empty();

  // display top 10 results
  results.slice(0, 10).forEach(function (result) {
    var resultNode = jQuery("<li>");
    resultNode.append(
      jQuery("<a>", {
        href: result.ref,
        text: result.title,
      }),
    );
    jQuery("#" + rid).append(resultNode);
  });
  jQuery("#" + rid)
    .parent()
    .show();
}

function renderSearchPageResults(result) {
  result.forEach(function (result) {
    var descnode = "";

    if (result.description) {
      descnode = jQuery("<p>", {
        text: result.description,
      }).text();
    }

    var searchparent = jQuery(".content");
    var divnode = jQuery("<div>", {
      class: "search-result clearfix",
    }).append(
      jQuery("<div>", {
        class: "search-result-inner flex",
      })
        .append(
          jQuery("<div>", {
            class: "search-result-content",
          })
            .append(
              jQuery("<a>", {
                href: result.ref,
                //- text: result.title
              }).append(
                jQuery("<h3>", {
                  //- href: result.ref,
                  text: result.title,
                }),
              ),
            )
            .append(descnode),
        )
        .append(
          jQuery("<div>", {
            class: "search-result-right-arrow",
          }).append(
            jQuery("<a>", {
              href: result.ref,
            }).append(
              jQuery("<i>", {
                class: "fa fa-angle-right",
                style: "color:#76ae99;font-size: 30px",
              }),
            ),
          ),
        )
        .append(
          jQuery("<div>", {
            style: "clear:both",
          }),
        ),
    );

    searchparent.append(divnode);
    jQuery("#search-term").html("");
  });
}

var rev = 1.0001;
initLunr();

jQuery(document).ready(function () {
  /**************** detect ie and add class for menu ****************/
  var uagent = window.navigator.userAgent;
  var isie = uagent.indexOf("MSIE ") > -1 || uagent.indexOf("Trident/") > -1;

  if (isie > 0) {
    $("#menu-main-navigation").addClass("ie-navigation");
  }

  /*************** handle menu drop down on zoom/window resize ******************/
  sc_methods.handleZoom();

  /**************** show/hide home page title and tagline on mobile devices  **************/
  var w_width = $(window).width();
  if (
    ($("body.pg-home").length > 0 || $("body.pg-resources").length > 0) &&
    w_width < 760
  ) {
    $(
      ".sc-hero-content:not(.product-highlight-hero .sc-hero-content)",
    ).addClass("sc-hidden");
    $(".product-intro .page-title").removeClass("sc-hidden");
  } else if ($("body.pg-blog").length > 0 && w_width < 1024) {
    $(".sc-hero-content").addClass("sc-hidden");
    $(".product-intro .page-title").removeClass("sc-hidden");
  } else {
    $(".sc-hero-content").removeClass("sc-hidden");
    if ($(".product-intro .page-title")) {
      $(".product-intro .page-title").addClass("sc-hidden");
    }
  }

  /******* initialilise site search input ************/
  //header search
  initSearch("site-search", "ss-results");
  //mobile search
  initSearch("mobile-search", "m-results");

  /******* check if search page, then carry out lunar search *******/
  var curpage = window.location.pathname;
  var searchstring = window.location.search.replace(
    "?",
    "",
  ); /* This is also used below for loading videos */

  if (curpage.indexOf("/search") != -1) {
    if (searchstring) {
      //initialilise search page input
      initSearch("page-search", "ps-results");

      var split = searchstring.split("=");

      //wait 1/2 a sec before carrying out search give lunr time to complete initialisation.
      setTimeout(function () {
        var result = search(split[1]);
        var term = split[1];

        jQuery("#sterm").text("'" + decodeURI(term) + "'");
        jQuery("#search-count").text(result.length);
        jQuery("#results-message").show();

        renderSearchPageResults(result);
      }, 500);
    } else {
      jQuery("#results-message").show();
    }
  }

  /**************** search symbol functionality ****************/
  $("#search-input").on("input", function () {
    const searchText = $(this).val().toLowerCase();
    const content = $(".content");

    content.find(".highlight").each(function () {
      $(this).replaceWith($(this).text());
    });

    if (searchText) {
      const regex = new RegExp(searchText, "gi");
      content.find("tr").each(function () {
        $(this)
          .find("td:not(:first-child)")
          .each(function () {
            const cell = $(this);
            cell.html(
              cell
                .html()
                .replace(
                  regex,
                  (match) => `<span class="highlight">${match}</span>`,
                ),
            );
          });
      });

      const firstMatch = $(".highlight").first();
      if (firstMatch.length) {
        $("html, body").animate(
          {
            scrollTop: firstMatch.offset().top - 320,
          },
          500,
        );
      }
    }
  });

  /********** Country Selection Popup ********/
  var getCookie = Cookies.get("popup5241"),
    siteIsHome = false,
    frd = false,
    qstring = location.search.replace("?", "");

  if ($("body.pg-home").length > 0) {
    siteIsHome = true;
  }

  var qarr = qstring.split("=");

  if (qarr && qarr[0] == "frd" && qarr[1] == "true") {
    frd = true;
  }

  var url = new URL(window.location);

  var pathname = url.pathname;
  var parts = pathname.split("/");
  var desiredPart = parts[parts.length - 1] || parts[parts.length - 2];
  var params = new URLSearchParams(url.search);

  if (params.has("thankyou")) {
    jQuery(".thankyou-popup").show();
    jQuery(".thankyou-overlay").show();
    gtag("event", "form_submission", {
      event_category: "Product Enquiry",
      event_label: desiredPart,
      url: pathname,
    });
  } else {
    jQuery(".thankyou-popup").hide();
    jQuery(".thankyou-overlay").hide();
  }

  $(document).click(function (event) {
    var $target = $(event.target);
    if (!$target.closest(".thankyou-popup").length) {
      jQuery(".thankyou-popup").hide();
      jQuery(".thankyou-overlay").hide();
      params.delete("thankyou");
      url.search = params.toString();
      window.history.replaceState({}, "", url);
    }
  });

  jQuery(".thankyou-close-btn").on("keypress click", function (e) {
    if (e.type === "keypress" && e.which !== ENTER_KEYCODE) {
      return;
    }

    jQuery(".thankyou-popup").hide();
    jQuery(".thankyou-overlay").hide();
    params.delete("thankyou");
    url.search = params.toString();
    window.history.replaceState({}, "", url);
  });

  // only show the country selection popup when it is not a redirect from the flag selection.
  if (!frd) {
    if (siteIsHome && getCookie) {
      jQuery(".online-access-popup").css({ display: "none" });
      jQuery(".overlay").css({ display: "none" });
    } else if (siteIsHome && getCookie == null) {
      jQuery(".online-access-popup").css({ display: "flex" });
      jQuery(".overlay").css({ display: "block" });
    } else {
      if ($("body.pg-online-access").length > 0) {
        jQuery("#select-online-access-popup").css({ display: "flex" });
        jQuery(".online-access-popup").css({ display: "flex" });
        jQuery(".overlay").css({ display: "block" });
      } else {
        jQuery("#select-online-access-popup").css({ display: "none" });
        jQuery(".online-access-popup").css({ display: "none" });
        jQuery(".overlay").css({ display: "none" });
      }
    }
  }

  /******* Cookie consent ******/
  var consent_cookie = Cookies.getJSON("sc_consent_cookie"),
    exp = 365;

  if (!consent_cookie) {
    $(".cookie-consent-wrapper").addClass("active");
  } else {
    $(".cookie-consent-wrapper").removeClass("active");
  }

  if ($("body.pg-resources").length > 0) {
    var el = document.getElementById("resource-submenu-items");

    if (el && el.scrollWidth < $(window).width()) {
      $(".sc-left-arrow").hide();
      $(".sc-right-arrow").hide();
    }
  }

  /** handle resource submenu button **/
  if ($("body.pg-resources").length > 0) {
    var subelem = document.getElementById("resource-submenu-items");
    if (subelem) {
      sc_methods.showHideSubmenuButton(subelem);
    }
  }

  /****** Bind all events ******/
  sc_methods.bindEvents();

  /******* open all pdf and external links in new page *******/
  jQuery(document.links)
    .filter(function () {
      // open all pdf in new tab
      if (
        this.href.indexOf(".pdf") > -1 &&
        this.href.indexOf(".pdf") + 4 == this.href.length
      ) {
        return true;
      }

      return (
        this.hostname != window.location.hostname &&
        (this.protocol == "https:" || this.protocol == "http:")
      );
    })
    .removeAttr("target")
    .attr("target", "_blank");

  /****** sales region on load *******/
  if (window.matchMedia("only screen and (max-width: 760px)").matches) {
    if ($(".tab-content-wrapper") && $(".tab-content-wrapper").length > 0) {
      $(".tab-content-wrapper").html("");

      var tab_content = $(".tab-title").attr("data-content");

      var tcontent = $("#" + tab_content)[0].outerHTML;
      $(".tab-content-wrapper." + tab_content).html(tcontent);
    }
  }

  /*******OPTIM OS1 Hero Video*******/
  $(".pg-optim-os1 .video-img").on("keypress click", function (e) {
    if (e.type === "keypress" && e.which !== ENTER_KEYCODE) {
      return;
    }
    $(".optim-video-container .video-play").show();
  });

  /*******Landing page slider*******/

  $(".pg-landing .arrow-left").on("keypress click", function (e) {
    if (e.type === "keypress" && e.which !== ENTER_KEYCODE) {
      return;
    }
    var lastVideo = $(".video-icon").last();
    $(".learning-video").prepend(lastVideo);
  });

  $(".pg-landing .arrow-right").on("keypress click", function (e) {
    if (e.type === "keypress" && e.which !== ENTER_KEYCODE) {
      return;
    }
    var firstVideo = $(".video-icon").first();
    $(".learning-video").append(firstVideo);
  });

  $(".landing-video-container .play-icon").on("keypress click", function (e) {
    if (e.type === "keypress" && e.which !== ENTER_KEYCODE) {
      return;
    }
    $(".video-img").hide();
    $(".video-play").show();
    $(".landing-video-container .play-icon").hide();
  });

  $(".video button").on("keypress click", function (e) {
    if (e.type === "keypress" && e.which !== ENTER_KEYCODE) {
      return;
    }
    $(".video-play").hide();
    $(".video-img").show();
    $(".landing-video-container .play-icon").show();

    var extendSrc = "?enablejsapi=1&amp;version=3&amp;playerapiid=ytplayer";

    if (
      jQuery(this).parent().find("iframe") &&
      jQuery(this).parent().find("iframe").length > 0
    ) {
      ogSource = jQuery(this).parent().find("iframe").attr("src");
      jQuery(this)
        .parent()
        .find("iframe")
        .attr("src", ogSource + extendSrc);
      jQuery(this)
        .parent()
        .find("iframe")[0]
        .contentWindow.postMessage(
          '{"event":"command","func":"' + "stopVideo" + '","args":""}',
          "*",
        );
    } else if (
      jQuery(this).parent().find("video") &&
      jQuery(this).parent().find("video").length > 0
    ) {
      ogSource = jQuery(this).parent().find("video source").attr("src");

      jQuery(this)
        .parent()
        .find("video source")
        .attr("src", ogSource + extendSrc);
      jQuery(this).parent().find("video")[0].pause();
    }

    e.stopPropagation();
  });

  /******* Slider Section *****/
  var win_width = $(window).width();

  $(".bxslider").each(function (index, slider) {
    var params = {};
    ((params.max_slides =
      win_width < 767
        ? 1
        : win_width > 767 && win_width < 1024
          ? 2
          : win_width > 1350
            ? 4
            : 3),
      (params.slide_width = 262.5),
      (params.slide_margin = 0));
    params.auto = false;
    params.stop_auto = false;
    params.infinit_loop = false;
    params.speed = 1000;
    params.pause = 4000;
    params.nextSelector = $("#right-arrow" + "-" + index);
    params.prevSelector = $("#left-arrow" + "-" + index);

    if ($(this).attr("class").indexOf("statim-bxslider") > -1) {
      params.slide_width = win_width < 767 ? 280 : win_width < 1024 ? 320 : 480;
      params.slide_margin = win_width < 767 ? 16 : 24;
      params.max_slides = win_width < 767 ? 1 : win_width < 1024 ? 2 : 3;
    }
    if ($(this).attr("class").indexOf("workflow-bxslider") > -1) {
      params.slide_width = win_width < 767 ? 300 : win_width < 1024 ? 340 : 400;
      params.slide_margin = win_width < 767 ? 16 : 28;
      params.max_slides = win_width < 767 ? 1 : win_width < 1024 ? 2 : 3;
    }
    /* banner sliders take up full screen width. only one slide displayed at a time. */
    if ($(this).attr("class").indexOf("banner-slider") > -1) {
      params.slide_width = 0; //use default value;
      params.max_slides = 1;
      params.auto = true;
      // params.stop_auto = true;
      params.infinit_loop = true;
      params.pause = 8000;
    } else {
      max_width = 1050;
      total_slides = $(this).children().length;
      params.slide_width =
        total_slides > 2 ? params.slide_width : max_width / total_slides; // or 400 for 2 or less

      if ($(this).attr("class").indexOf("thumbnail") > -1) {
        params.max_slides = win_width < 767 ? 1 : 2;
        ((params.slide_width = win_width < 767 ? 120 : 150),
          (params.slide_margin = win_width < 767 ? 10 : 40));
      }
    }

    sc_methods.initSliders(slider, params);
  });

  /******* lazy load img ******/
  sc_methods.lazyLoadImg();
  sc_methods.loadOnScroll();

  /******* initialize Store Locator Plugin ( load only when available )**********/
  if (typeof $.fn["storeLocator"] !== "undefined") {
    sc_methods.initStoreLocator();
  }

  /**************** trigger video load based on url query string ********************/
  if (searchstring.indexOf("w=1") != -1 && searchstring.indexOf("v=") > 1) {
    var sp = searchstring.split("&");

    for (var i in sp) {
      var ar = sp[i].split("=");

      if (ar[0] == "v") {
        sc_methods.loadVideo(ar[1]);
        break;
      }
    }
  } else if (searchstring.indexOf("w=1") != -1) {
    sc_methods.scrollToVideo();
  }

  // clear all input on page load.
  $('input[type="checkbox"]').prop("checked", false);
  $('input[type="text"]').val("");

  /******************* Video Page *******************/
  if (curpage.indexOf("/video") != -1) {
    var str_split = searchstring.split("&");
    var vid = "";
    var vtitle = "";
    var vdate = "";

    for (var i in str_split) {
      var arr = str_split[i].split("=");

      switch (arr[0]) {
        case "v":
          vid = arr[1];
          break;
        case "t":
          vtitle = arr[1];
          break;
        case "u":
          vdate = arr[1];
          break;
        default:
          break;
      }
    }
  }
  /******************* End Video Page **************/

  /******************* Warranty page *******************/
  if (curpage.indexOf("/warranty") != -1) {
    var querystring = window.location.search.replace("?", "");

    if (querystring.indexOf("onlineaccess" != -1)) {
      var furl = $("#wrframe").attr("src");
      var nurl =
        furl.indexOf("?") > -1 ? furl + "&" + querystring : "?" + querystring;

      $("#wrframe").attr("src", nurl);

      $("#wrframe").on("load", function () {
        window.parent.scrollTo(0, 0);
      });
    }
  }
  /******************* End Warranty page *******************/
});
//end document ready

/* general methods */

var sc_methods = {
  toggleCaret: function (el, toggleElem) {
    if (toggleElem) {
      toggleElem.slideToggle(400);
    }

    if ($(el).hasClass("fa-caret-up")) {
      $(el).removeClass("fa-caret-up").addClass("fa-caret-down");
      $(el)
        .parents(".feature-items")
        .find(".feature-icon")
        .removeClass("active");
    } else {
      $(el).removeClass("fa-caret-down").addClass("fa-caret-up");

      $(el)
        .parents(".feature-items")
        .find(".feature-icon")
        .removeClass("active")
        .addClass("active");
    }
  },

  closeModal: function (el) {
    el.hide();
  },
  showHideScrollImage: function () {
    //add scroll image to table
    if ($(".bravo-chamber-sterilization-container")) {
      if (
        $(".bravo-chamber-sterilization-container table").width() >
        $(".bravo-chamber-sterilization-container").width()
      ) {
        $(".bravo-chamber-sterilization-container table")
          .parent()
          .append(
            $("<img>").attr({
              src: "/images/products/show-more.png",
              class: "more-table",
            }),
          )
          .on("keypress click", function (e) {
            if (e.type === "keypress" && e.which !== ENTER_KEYCODE) {
              return;
            }

            var new_pos =
              $(".bravo-chamber-sterilization-container > div").scrollLeft() +
              100;
            $(".bravo-chamber-sterilization-container > div").scrollLeft(
              new_pos,
            );
          });
      } else {
        $(".bravo-chamber-sterilization-container .more-table").hide();
      }
    }
  },
  loadOnScroll: function () {
    $(window).scroll(function () {
      $.each($("img"), function () {
        if (
          $(this).attr("data-src") &&
          $(this).offset().top <
            $(window).scrollTop() + $(window).height() + 100
        ) {
          var source = $(this).data("src");
          $(this).attr("src", source);
          $(this).removeAttr("data-src");
          this.classList.remove("img-loading");
        }
      });

      //load 2 videos max. other videos will load on click
      $.each($("iframe"), function (k, v) {
        if ($(this).attr("data-src") && k < 2) {
          var source = $(this).data("src");
          $(this).attr("src", source);
          $(this).removeAttr("data-src");
          this.classList.remove("img-loading");
        }
      });

      //load video tag image
      $.each($("video source"), function (k, v) {
        if ($(this).attr("data-src") && k < 2) {
          var source = $(this).data("src");
          $(this).attr("src", source);
          $(this).removeAttr("data-src");
          $(this).parent()[0].load();
        }
      });
    });
  },
  lazyLoadImg: function () {
    window.addEventListener(
      "load",
      function () {
        var lazy_images = document.getElementsByClassName("lazy-load");
        for (var i = 0; i < lazy_images.length; i++) {
          var tn = lazy_images[i].tagName;
          if (
            lazy_images[i].getAttribute("data-src") &&
            tn.toLowerCase().indexOf("img") > -1
          ) {
            lazy_images[i].setAttribute(
              "src",
              lazy_images[i].getAttribute("data-src"),
            );
            lazy_images[i].classList.remove("img-loading");
            //remove data-src attribute
            lazy_images[i].removeAttribute("data-src");

            if (tn.toLowerCase().indexOf("iframe") > -1) {
              $(lazy_images[i]).load(function (ev) {
                $(this).parent().find(".fa-spinner").hide();
              });
            }
          }
        }
      },
      false,
    );
  },
  removeLazyLoad: function (el) {
    if (el.getAttribute("data-src")) {
      el.setAttribute("src", el.getAttribute("data-src"));
      el.classList.remove("img-loading");
      el.removeAttribute("data-src");
      $(el)
        .parent()
        .append(
          $("<i>").attr({ class: "fas fa-spinner fa-pulse fa-3x fa-fw" }),
        );

      if (el.tagName.toLowerCase() == "source") {
        $(el).parent().load();
      }

      $(el).load(function (ev) {
        $(this).parent().find(".fa-spinner").hide();
      });
    }
  },
  initSliders: function (xslider, params) {
    var slider_params = {
      speed: params.speed,
      pause: params.pause,
      infiniteLoop: params.infinit_loop, //true,
      hideControlOnEnd: true,
      minSlides: params.min_slides ? params.min_slides : 1,
      maxSlides: params.max_slides,
      slideWidth: params.slide_width, //262.5,
      slideMargin: params.slide_margin,
      controls: true,
      captions: false,
      auto: params.auto, //true,
      stopAutoOnClick: params.stop_auto, //true,
      pager: true,
      nextText: "",
      prevText: "",
      nextSelector: params.nextSelector,
      prevSelector: params.prevSelector,
      // touchEnabled: false,
      onSliderLoad: function (cidx, slider) {
        var cnt = this.getSlideCount();

        if ($(".product-accessories .flex-content").length > 0) {
          $(".product-accessories .flex-content").css("visibility", "visible");
        }

        if ($(".sc-hero .flex-content").length > 0) {
          $(".sc-hero .flex-content").css("visibility", "visible");
        }

        if (cnt > params.max_slides) {
          $(".flex-content .sc-arrow").addClass("active");
          $(".flex-content .sc-arrow").css("visibility", "visible");
        }
      },
    };
    var ischrome =
      window.navigator.userAgent.toLowerCase().indexOf("chrome") > -1;
    var isie =
      window.navigator.userAgent.indexOf("MSIE ") > -1 ||
      window.navigator.userAgent.indexOf("Trident/") > -1 ||
      window.navigator.userAgent.indexOf("Edge") > -1;

    if (
      navigator.maxTouchPoints != "undefined" &&
      navigator.maxTouchPoints < 1 &&
      ischrome &&
      isie == false
    ) {
      slider_params.touchEnabled = false;
    }

    if (typeof $.fn.bxSlider == "function") {
      //sliders
      var acc_slider = $(xslider).bxSlider(slider_params);

      if (acc_slider && $(this).length > 0) {
        $(window).resize(function () {
          var scnt = acc_slider.getSlideCount();
          win_width = $(window).width();
          sliderElement = acc_slider.getSlideElement();
          var mxSlides =
            win_width < 767
              ? 1
              : win_width == 768
                ? 2
                : win_width == 1024
                  ? 3
                  : 4;

          /* if banner sliders, no more processing */
          if (sliderElement.context.className.indexOf("banner-slider") > -1) {
            // mxSlides = 1;
            // slider_params.slideWidth = win_width;
            return;
          }

          if (sliderElement.context.className.indexOf("thumbnail") > -1) {
            mxSlides = win_width < 767 ? 1 : 2;
          }
          slider_params.maxSlides = mxSlides;
          acc_slider.reloadSlider(slider_params);

          $(".sc-left-arrow").css("visibility", "visible");
          $(".sc-right-arrow").css("visibility", "visible");
          $(".bx-controls.bx-has-pager").css("visibility", "visible");

          if (mxSlides >= scnt) {
            $(".sc-left-arrow").css("visibility", "hidden");
            $(".sc-right-arrow").css("visibility", "hidden");
            $(".bx-controls.bx-has-pager").css("visibility", "hidden");
          }
        });

        var slide_cnt = acc_slider.getSlideCount();

        $(".sc-left-arrow").css("visibility", "visible");
        $(".sc-right-arrow").css("visibility", "visible");
        $(".bx-controls.bx-has-pager").css("visibility", "visible");

        if (params.max_slides >= slide_cnt) {
          $(".sc-left-arrow").css("visibility", "hidden");
          $(".sc-right-arrow").css("visibility", "hidden");
          $(".bx-controls.bx-has-pager").css("visibility", "hidden");
        }

        $(params.nextSelector).on("keypress click", function (e) {
          if (e.type === "keypress" && e.which !== ENTER_KEYCODE) {
            return;
          }
          acc_slider.goToNextSlide();
        });

        $(params.prevSelector).on("keypress click", function (e) {
          if (e.type === "keypress" && e.which !== ENTER_KEYCODE) {
            return;
          }
          acc_slider.goToPrevSlide();
        });
      }
    }

    //handle click events
    $(".product-accessories .flex-content a:not(.bx-pager-link)").on(
      "keypress click",
      function (e) {
        if (e.type === "keypress" && e.which !== ENTER_KEYCODE) {
          return;
        }
        var dname = $(this).attr("data-name");

        $(".accessories-modal .accessory-popup").hide();
        $(".accessories-modal ." + dname).fadeIn(300);
        $(".accessories-modal").addClass("active").fadeIn(300);
        $("html, body").css("overflowY", "hidden");
      },
    );

    $(".product-thumbnail a").on("keypress click", function (e) {
      if (e.type === "keypress" && e.which !== ENTER_KEYCODE) {
        return;
      }
      $(".product-thumbnail a .img-container").removeClass("active");

      var datasrc = $(this).attr("data-src"),
        dataalt = $(this).attr("data-alt");

      $(".feature-content.features")
        .find(".main-image img")
        .attr("src", datasrc)
        .attr("alt", dataalt);
      $(this).find(".img-container").addClass("active");
    });
  },
  trackOutboundLink: function (url) {
    if (typeof gtag !== "undefined") {
      gtag("event", "click", {
        event_category: "outbound",
        event_label: url,
        transport_type: "beacon",
        event_callback: function () {
          window.open(url, "_blank");
        },
      });
    }

    return false;
  },
  bindEvents: function () {
    /*** resource page menu ***/
    if ($("body.pg-resources").length > 0) {
      $(".sub-menu-item").on("keypress click", function (e) {
        if (e.type === "keypress" && e.which !== ENTER_KEYCODE) {
          return;
        }
        var ref = $(this).data("ref");
        var id = $(this).attr("id");

        if (ref.indexOf("#") > -1 && id.indexOf("tips") == -1) {
          self.location.href = ref;

          $("html, body").animate(
            {
              scrollTop: $(ref).offset().top - 80,
            },
            0,
          );
        } else if (
          ref.indexOf("#") == -1 &&
          (id.indexOf("reopen") > -1 || id.indexOf("tips") > -1)
        ) {
          var countrycode = scBaseURL.replace(/\//g, "");

          if (countrycode.indexOf("eu") != -1) {
            id.indexOf("tips") > -1
              ? $("#tips-country-popup").css({ display: "flex" })
              : window.open(ref, "_blank");
          } else {
            if (ref.indexOf("media") > -1) {
              window.open(ref, "_blank");
            } else {
              location.href = $(this).data("ref");
            }
          }
        }
      });

      $(window).on("beforeunload", function () {
        $("#tips-country-popup").css({ display: "none" });
      });

      /** submenu scroll handling for show/hide button **/
      $(".resource-submenu-items").scroll(function () {
        sc_methods.showHideSubmenuButton(this);
      });
    }
    /**** end resource page ***/

    /** google analytics **/
    $(
      "a, button, .tab-title, .feature-title, .nav-search, .product-accessories .flex-content a, .media-wrapper, .f-table, .career .title, .question-container",
    ).on("keypress click", function (e) {
      if (e.type === "keypress" && e.which !== ENTER_KEYCODE) {
        return;
      }
      var data_analytics = $(this).attr("data-analytics");
      if (data_analytics && data_analytics.length > 0) {
        data_analytics = JSON.parse(data_analytics);

        if (typeof useGtm !== "undefined" && useGtm) {
          window.dataLayer.push({
            event: "scclick",
            action: "click",
            eventCategory: data_analytics.category,
            eventLabel: data_analytics.label,
          });
        } else if (typeof gtag !== "undefined") {
          gtag("event", data_analytics.event, {
            event_category: data_analytics.category,
            event_label: data_analytics.label,
          });
        }
      } else if (typeof useGtm !== "undefined" && useGtm) {
        dataLayer.push({
          event: "scclick",
          action: "click",
          eventCategory: "link",
          eventLabel: $(this).attr("href"),
        });
      } else if (
        typeof gtag !== "undefined" &&
        (!data_analytics || (data_analytics && data_analytics.length == 0)) &&
        $(this).prop("tagName").toLowerCase() == "a" &&
        (typeof $(this).attr("class") == "undefined" ||
          (typeof $(this).attr("class") !== "undefined" &&
            $(this).attr("class").indexOf("outbound-link") == -1))
      ) {
        gtag("event", "click", {
          event_category: "link",
          event_label: $(this).attr("href"),
        });
      }
    });

    $(".outbound-link").on("keypress click", function (e) {
      if (e.type === "keypress" && e.which !== ENTER_KEYCODE) {
        return;
      }
      sc_methods.trackOutboundLink($(this).attr("href"));
    });

    /*************************/
    /***** open/close sections *********/
    $(
      ".feature-title:not(.features-extra .feature-title):not(.pg-campaign .feature-title), .career .title, .question-container",
    ).on("keypress click", function (e) {
      if (e.type === "keypress" && e.which !== ENTER_KEYCODE) {
        return;
      }
      var toggleElem = $(this).next();

      sc_methods.toggleCaret($(this).find("i"), toggleElem);

      if ($(this).attr("class").indexOf("question-container") > -1) {
        /*send anaylytics event */
        var questions = jQuery(this).parent().find(".fq-quest").html();

        if (typeof ga != "undefined") {
          var gaLabel =
            "faq: " +
            $.trim(questions.replace("<em>", "").replace("</em>", ""));
          ga("send", "event", "FAQ", "Click", gaLabel);
        }
      }
    });

    $(".f-table h5").on("keypress click", function (e) {
      if (e.type === "keypress" && e.which !== ENTER_KEYCODE) {
        return;
      }
      var toggleElem = $(this).next();

      sc_methods.toggleCaret($(this).find("i"), toggleElem);
    });

    //show/hide table scroll image

    /***** resize Enquiry iframes *****/
    $(".enquiry-frame").on("load resize", function () {
      this.style.height = this.contentDocument.body.scrollHeight + "px";

      $(".product-enquiry .frame-container").height(this.style.height);
    });

    $(window).resize(function () {
      $(".enquiry-frame, .product-enquiry .frame-container").height(0);
      $(".enquiry-frame, .product-enquiry .frame-container").height(
        $(".enquiry-frame").contents().outerHeight(),
      );

      /*********** handle home page show/hide hero text ************/
      var w_width = $(window).width();
      if (
        ($("body.pg-home").length > 0 || $("body.pg-resources").length > 0) &&
        w_width < 760
      ) {
        $(
          ".sc-hero-content:not(.product-highlight-hero .sc-hero-content)",
        ).addClass("sc-hidden");
        $(".product-intro .page-title").removeClass("sc-hidden");
      } else if ($("body.pg-blog").length > 0 && w_width < 1024) {
        $(".sc-hero-content").addClass("sc-hidden");
        $(".product-intro .page-title").removeClass("sc-hidden");
      } else {
        $(".sc-hero-content").removeClass("sc-hidden");
        if ($(".product-intro .page-title")) {
          $(".product-intro .page-title").addClass("sc-hidden");
        }
      }

      /** resources page sub menu - handle scroll buttons**/
      if ($("body.pg-resources").length > 0) {
        /** handle resource submenu button **/
        var subelem = document.getElementById("resource-submenu-items");
        sc_methods.showHideSubmenuButton(subelem);
      }

      // show/hide table scroll image.
      /**** sc_methods.showHideScrollImage(); ****/
    });

    /***** handle tab click *****/
    jQuery(".tab-title ").on("keypress click", function (e) {
      if (e.type === "keypress" && e.which !== ENTER_KEYCODE) {
        return;
      }
      var tab_content = jQuery(this).attr("data-content");
      $(".tab-content-wrapper").html("");

      var caretclass = $(this).find("i").attr("class");

      $(".tab-title p")
        .removeClass("sc-selected")
        .find("i")
        .removeClass("fa-caret-up fa-caret-down sc-selected")
        .addClass("fa-caret-down");

      $(this).find("p").addClass("sc-selected");

      sc_methods.toggleCaret($(this).find("i"), null);

      if (
        window.matchMedia("only screen and (max-width: 760px)").matches &&
        $(".tab-content-wrapper") &&
        $(".tab-content-wrapper").length > 0
      ) {
        var tcontent = $("#" + tab_content)[0].outerHTML;
        $(".tab-content-wrapper").html("");
        if (caretclass.indexOf("fa-caret-down") > -1) {
          $(".tab-content-wrapper." + tab_content).html(tcontent);
        } else {
          $(".tab-title." + tab_content + " p")
            .removeClass("sc-selected")
            .find("i")
            .removeClass("fa-caret-up fa-caret-down sc-selected")
            .addClass("fa-caret-down");
        }
      } else {
        $(".tab-content").removeClass("sc-hide").addClass("sc-hide");
        $(".tab-content." + tab_content).removeClass("sc-hide sc-hidden");
      }
    });

    /***** FAQ - not used right now *****/
    jQuery(".faq-question--").on("keypress click", function (e) {
      if (e.type === "keypress" && e.which !== ENTER_KEYCODE) {
        return;
      }
      var curclass = jQuery(this).find("span:visible").attr("class");

      if (curclass == "fopen") {
        jQuery(this).find(".fopen").css("display", "none");
        jQuery(this).find(".fclose").css("display", "inline-block");

        /*send anaylytics event */
        var questions = jQuery(this).find(".fq-quest").html();

        if (typeof ga != "undefined") {
          var gaLabel =
            "faq: " +
            $.trim(questions.replace("<em>", "").replace("</em>", ""));
          ga("send", "event", "FAQ", "Click", gaLabel);
        }

        /*jQuery(this).parent().css("background-color", "#f0f0f0");*/
      } else {
        jQuery(this).find(".fclose").css("display", "none");
        jQuery(this).find(".fopen").css("display", "inline-block");
        /*jQuery(this).parent().css("background-color", "#ffffff");*/
      }
      jQuery(this).parent().parent().children(".faq-content").toggle();
    });

    /*** newsletter subscription ***/
    $(".subscribe-submit-btn").submit(function (e) {
      var k = 0;
      if (e.type == "keypress") {
        k = e.which;
      }

      e.preventDefault();
      return false;
      if (e.type == "click" || k == 13) {
        //$('this').closest('form').submit();
      }
    });

    /***** Change Country *****/
    jQuery("#change-country").on("keypress click", function (e) {
      if (e.type === "keypress" && e.which !== ENTER_KEYCODE) {
        return;
      }
      jQuery(this)
        .children("i")
        .toggleClass("fa-angle-down")
        .toggleClass("fa-angle-right");
      jQuery("#country-list").toggleClass("open");
    });

    /**** set country selection cookie ****/
    jQuery(".setPopupCookie").on("keypress click", function (e) {
      if (e.type === "keypress" && e.which !== ENTER_KEYCODE) {
        return;
      }

      if (e.type === "click") {
        e.preventDefault();
      }

      Cookies.set("popup5241", "5241", { expires: 7 });

      //add query params to href;
      var pname = location.pathname;
      var href = $(this).attr("href");

      if ($("body.pg-online-access").length > 0) {
        href = href.split("?")[0] + "online-access/?frd=true";
      }

      location.href = href;
    });

    /*** Cooke Consent Handling ***/
    $(".decline-cookie").on("keypress click", function (e) {
      if (e.type === "keypress" && e.which !== ENTER_KEYCODE) {
        return;
      }
      $(".cookie-consent-wrapper").slideToggle("slow");
    });

    $(".consent-cookie").on("keypress click", function (e) {
      if (e.type === "keypress" && e.which !== ENTER_KEYCODE) {
        return;
      }
      var cdate = new Date(),
        exp = 365;

      Cookies.set("sc_consent_cookie", { date: cdate }, { expires: exp });
      $(".cookie-consent-wrapper").slideToggle("slow").removeClass("active");
    });

    /******** Dealer Search submit Click *********/
    $("#dealer-search-form #submit-wrapper").on("keypress click", function (e) {
      if (e.type === "keypress" && e.which !== ENTER_KEYCODE) {
        return;
      }
      var p = $(this).parent();

      if (p.find("input").val() == "") {
        p.find(".dealer-search-error").removeClass("sc-hidden");
      } else {
        p.find(".dealer-search-error")
          .removeClass("sc-hidden")
          .addClass("sc-hidden");
      }
    });

    /******************** Modal ********************/
    $(".learn-more.popup").on("keypress click", function (e) {
      if (e.type === "keypress" && e.which !== ENTER_KEYCODE) {
        return;
      }
      var dname = $(this).attr("data-name");

      $(".sc-modal .sc-popup").hide();
      $(".sc-modal ." + dname).fadeIn(300);
      $(".sc-modal").addClass("active").fadeIn(300);
      $("html, body").css("overflowY", "hidden");
    });

    $(".go-to-line").on("keypress click", function (e) {
      if (e.type === "keypress" && e.which !== ENTER_KEYCODE) {
        return;
      }
      var ref = $(this).attr("data-ref");

      if ($("#" + ref) && $("#" + ref).length > 0) {
        //expand collapsed data
        if (
          $("#" + ref + " .feature-title") &&
          $("#" + ref + " .feature-title").length > 0 &&
          $("#" + ref + " .feature-description").css("display") == "none"
        ) {
          $("#" + ref + " .feature-title").trigger("click");
        }

        jQuery("html, body").animate(
          {
            scrollTop: $("#" + ref).offset().top - 110,
          },
          2000,
        );
        return false;
      }
    });

    /** online access **/
    $(".online-access .tab-option").on("keypress click", function (e) {
      if (e.type === "keypress" && e.which !== ENTER_KEYCODE) {
        return;
      }
      var content = $(this).data("tab");

      if (content) {
        $(".online-access .tab-option").removeClass("active");
        $(this).addClass("active");

        $(".online-access .tab-content > div").addClass("sc-hidden");
        $(".online-access .tab-content ." + content).removeClass("sc-hidden");
      }
    });

    $(".email-form").submit(function (e) {
      e.preventDefault();
      $(this).find("input").removeClass("err");
      $(".error-msg").addClass("sc-hidden");
      $(".status-msg").html("").addClass("sc-hidden");

      var fdata = $(this).serializeArray();
      var len = fdata.length;
      var token = fdata[1].value;
      var email = fdata[0].value;
      var token2 = fdata[2] ? fdata[2].value : null;
      var token3 = fdata[3] ? fdata[3].value : null;
      var err = false;

      if (!sc_methods.validateEmail(email)) {
        $(this).find('input[name="email"]').addClass("err");
        err = true;
      }
      if (token.length < 7) {
        $(this)
          .find('input[name="' + fdata[1].name + '"]')
          .addClass("err");
        err = true;
      }
      if (token2 != null && token2.length < 7) {
        $(this)
          .find('input[name="' + fdata[2].name + '"]')
          .addClass("err");
        err = true;
      }
      if (token3 != null && token3.length < 7) {
        $(this)
          .find('input[name="' + fdata[3].name + '"]')
          .addClass("err");
        err = true;
      }

      if (err) {
        $(".error-msg").removeClass("sc-hidden");
        return;
      }

      var data = {
        email: email,
        token: token,
      };

      data.token += token2 ? ";" + token2 : "";
      data.token += token3 ? ";" + token3 : "";

      sc_methods.sendMail(data);
    });

    $(".token-wrapper .add-token").on("keypress click", function (e) {
      if (e.type === "keypress" && e.which !== ENTER_KEYCODE) {
        return;
      }
      var count = $('.token-wrapper input[name^="token"]').length;
      var trans = $(this).data("translations");

      if (count < 3) {
        var div = $("<div>")
          .attr("class", "token-input")
          .append(
            $("<input>").attr({
              type: "text",
              name: "token" + (count + 1),
              maxlength: "7",
              size: "15",
              placeholder: trans.placeholder,
            }),
          )
          .append(
            $("<div>")
              .attr({ class: "delete-field", title: trans.title })
              .text("-")
              .on("keypress click", function (e) {
                if (e.type === "keypress" && e.which !== ENTER_KEYCODE) {
                  return;
                }
                $(this).parent().remove();
              }),
          );

        $(".token-wrapper").append(div);

        return;
      }

      $(".max-token-msg").html(trans.max_token_msg).removeClass("sc-hidden");
    });

    $(document).on(
      "keyup",
      '.token-wrapper input[name^="token"]',
      function (e) {
        var val = $(this).val().trim();
        val = val.split("-").join("");
        var newVal = val ? val.match(/.{1,3}/g).join("-") : "";

        if (newVal.length === 3 && e.which !== 8 && e.which !== 46) {
          newVal = newVal + "-";
        }

        $(this).val(newVal);
      },
    );
  },
  bindReadmoreToggle: function () {
    /**
     * Read More/Less Toggle
     * @type {[type]}
     */

    jQuery(".read-more-label, .read-less-label").on(
      "keypress click",
      function (e) {
        if (e.type === "keypress" && e.which !== ENTER_KEYCODE) {
          return;
        }
        var curElem = this.getAttribute("class");

        jQuery(".read-more-content").removeClass("active");
        if (curElem == "read-more-label") {
          $(this).hide();
          $(".read-less-label").show();
          jQuery(".read-more-content").addClass("active");
        } else {
          $(this).hide();
          $(".read-more-label").show();
        }
      },
    );
  },
  handleZoom: function () {
    var outer_width = window.outerWidth;
    if (outer_width > 1114) {
      var outer_width = window.outerWidth;
      var inner_width = window.innerWidth;
      var initial_zoom = (window.outerWidth - 10) / window.innerWidth;

      if (initial_zoom > 1 || initial_zoom < 1) {
        // inner width is diferent from outer width so page is zoomed or resized.

        if (outer_width > inner_width) {
          //page is zoomed in. i.e. ineer width is greater than outer width

          if (initial_zoom > 1.3) {
            //console.log('Orig greater than 140% ');
            // change col width and gap
            //$('.main-navgiation ul.menu>li.menu-item-has-children:nth-of-type(2)>ul.sub-menu').addClass('two-cols');
            $(
              ".main-navgiation ul.menu>li.menu-item-has-children:nth-of-type(2)>ul.sub-menu",
            ).css({ "column-count": 2, "column-gap": "10px" });
          } else {
            //console.log('Orig less than 140% ');
            //$('.main-navgiation ul.menu>li.menu-item-has-children:nth-of-type(2)>ul.sub-menu').remove('two-cols');
            $(
              ".main-navgiation ul.menu>li.menu-item-has-children:nth-of-type(2)>ul.sub-menu",
            ).css({ "column-count": 3, "column-gap": "initial" });
          }
        }
      } else {
        //console.log('Orig 100% ' );
        //$('.main-navgiation ul.menu>li.menu-item-has-children:nth-of-type(2)>ul.sub-menu').remove('two-cols');
        $(
          ".main-navgiation ul.menu>li.menu-item-has-children:nth-of-type(2)>ul.sub-menu",
        ).css({ "column-count": 3, "column-gap": "initial" });
      }

      $(window).resize(function () {
        var owidth = window.outerWidth;
        var iwidth = window.innerWidth;
        var pageHasZoom = window.outerWidth == window.innerWidth;

        // var zoom = ( window.outerWidth - 10 ) / window.innerWidth;
        var zoom = window.outerWidth / window.innerWidth;

        if (zoom > 1 || zoom < 1) {
          // inner width is diferent from outer width so page is zoomed or resized.
          var percentZoom = zoom * 100;
          if (owidth > iwidth) {
            //page is zoomed in. i.e. ineer width is greater than outer width

            if (zoom > 1.4) {
              //console.log('greater than 140% ');
              // change col width and gap
              //$('.main-navgiation ul.menu>li.menu-item-has-children:nth-of-type(2)>ul.sub-menu').addClass('two-cols');
              $(
                ".main-navgiation ul.menu>li.menu-item-has-children:nth-of-type(2)>ul.sub-menu",
              ).css({ "column-count": 2, "column-gap": "10px" });
            } else {
              //console.log('less than 140% ');
              //$('.main-navgiation ul.menu>li.menu-item-has-children:nth-of-type(2)>ul.sub-menu').removeClass('two-cols');
              $(
                ".main-navgiation ul.menu>li.menu-item-has-children:nth-of-type(2)>ul.sub-menu",
              ).css({ "column-count": 3, "column-gap": "initial" });
            }
          }
        } else {
          //console.log(' 100% ' );
          //$('.main-navgiation ul.menu>li.menu-item-has-children:nth-of-type(2)>ul.sub-menu').removeClass('two-cols');
          $(
            ".main-navgiation ul.menu>li.menu-item-has-children:nth-of-type(2)>ul.sub-menu",
          ).css({ "column-count": 3, "column-gap": "initial" });
        }
      });
    }
  },
  initStoreLocator: function () {
    default_lat = "";
    default_lng = "";

    var countrycode = scBaseURL.replace(/\//g, ""),
      lat = "",
      lng = "",
      default_locations = {
        de: {
          lat: "50.4022212", //52.5065133
          lng: "9.2732099", //13.1445545
          lenght_unit: "km",
          translation: {
            address_error: "Die Adresse kann nicht gefunden werden",
            auto_geocode_error:
              "Die automatische Standorterkennung hat zu keinem Ergebnis geführt. Bitte geben Sie Ihre Adresse oder Ihre Postleitzahl ein.",
            kilometer: "Kilometer",
            kilometers: "Kilometers",
            mile: "Meile",
            miles: "Meilen",
            no_result_title: "Keine Ergebnisse",
            no_results_desc:
              "Zu den angegebenen Suchkriterien wurden keine Standorte gefunden. Bitte ändern Sie Ihre Auswahl oder Eingabe.",
            fax: "Fax",
            phone: "Telefon",
          },
        },
        eu: {
          lat: "54.9699146", //51.0899232
          lng: "-2.4804352", //-0.2416799
          lenght_unit: "km",
          translation: {
            address_error: "Unable to find address",
            auto_geocode_error:
              "Automatic location detection failed. Please fill in your address or zip code.",
            kilometer: "kilometer",
            kilometers: "kilometers",
            mile: "mile",
            miles: "miles",
            no_result_title: "No results",
            no_results_desc:
              "No locations were found with the given criteria. Please modify your selections or input.",
            fax: "Fax",
            phone: "Phone",
          },
        },
        jp: {
          lat: "35.0124633", //35.48847
          lng: "134.8562373", //137.5263065
          lenght_unit: "km",
          translation: {
            address_error: "住所が見つかりませんでした",
            auto_geocode_error:
              "自動検出に失敗しました。住所またはZIP/郵便番号を入力してください。",
            kilometer: "キロメートル",
            kilometers: "キロメートル",
            mile: "マイル",
            miles: "マイル",
            no_result_title: " 結果なし",
            no_results_desc:
              "入力された基準から場所を発見できませんでした。選択内容または入力内容を変更してください。",
            fax: "ファックス",
            phone: "電話",
          },
        },
        cn: {
          lat: "35.0078227", //35.0078227
          lng: "112.9200324", //112.9200324
          lenght_unit: "km",
          translation: {
            address_error: "无法找到地址",
            auto_geocode_error:
              " 地点自动检测失败。 请填写您的地址或邮政编码。",
            kilometer: "公里",
            kilometers: "公里",
            mile: "英里",
            miles: "英里",
            no_result_title: "无结果",
            no_results_desc:
              "没有找到符合指定标准的地点。 请修改您的选择或输入内容。",
            fax: "传真",
            phone: "电话",
          },
        },
        lam: {
          lat: "54.9699146", //51.0899232
          lng: "-2.4804352", //-0.2416799
          lenght_unit: "km",
          translation: {
            address_error: "No se puede encontrar la dirección",
            auto_geocode_error:
              "La detección automática de la ubicación falló. Por favor, complete su dirección o código postal.",
            kilometer: "kilómetro",
            kilometers: "kilómetros",
            mile: "milla",
            miles: "millas",
            no_result_title: "Sin resultados",
            no_results_desc:
              "No se encontraron ubicaciones con los criterios dados. Por favor, modifique sus selecciones o la información que ingresó.",
            fax: "Fax",
            phone: "Teléfono",
          },
        },
      };

    // add translated phone and fax label to location data.
    var labels = [];
    var location_data = {};
    labels.phonelbl =
      default_locations[countrycode] &&
      typeof default_locations[countrycode] != "undefined"
        ? default_locations[countrycode].translation.phone
        : default_locations.gb.translation.phone;
    labels.faxlbl =
      default_locations[countrycode] &&
      typeof default_locations[countrycode] != "undefined"
        ? default_locations[countrycode].translation.fax
        : default_locations.gb.translation.fax;

    sc_methods.processDealerMapRequest(default_locations, labels);
  },
  processDealerMapRequest: function (default_locations, labels) {
    default_lat = "";
    default_lng = "";

    var jsonfile = scBaseURL + "dealer_locations.json",
      countrycode = scBaseURL.replace(/\//g, ""),
      lat = "",
      lng = "";
    labels = labels ? labels : [];

    sc_methods.getJsonFile(jsonfile, {}, function (data) {
      var jdata = JSON.parse(data);
      var map_data = {};

      if (jdata.length > 0) {
        var timer = 200;
        for (var i = 0; i < jdata.length; i++) {
          var id = jdata[i]["id"];
          if (id > 0) {
            for (var k in labels) {
              jdata[i][k] = labels[k];
            }
          }
        }
      }

      //set default lat/lng
      if (!lat && !lng) {
        lat =
          default_locations[countrycode] &&
          typeof default_locations[countrycode] != "undefined"
            ? default_locations[countrycode]["lat"]
            : lat;
        lng =
          default_locations[countrycode] &&
          typeof default_locations[countrycode] != "undefined"
            ? default_locations[countrycode]["lng"]
            : lng;

        default_lat = lat;
        default_lng = lng;
      }

      map_data = {
        dataType: "json",
        // dataLocation: scBaseURL+'dealer_locations.json',
        dataRaw: jdata,
        distanceAlert: -1, //-1, 500,
        // altDistanceNoResult: true,
        openNearest: false,
        defaultLoc: true,
        slideMap: false,
        featuredLocations: true,
        storeLimit: -1,
        defaultLat: lat,
        defaultLng: lng,
        listColor1: "#fff",
        listColor2: "#fff", //
        disableAlphaMarkers: true,
        lengthUnit:
          default_locations[countrycode] &&
          typeof default_locations[countrycode] != "undefined"
            ? default_locations[countrycode]["lenght_unit"]
            : "m",
        //maxDistance: true,
        addressErrorAlert:
          default_locations[countrycode] &&
          typeof default_locations[countrycode] != "undefined"
            ? default_locations[countrycode].translation.address_error
            : default_locations.gb.translation.address_error,
        autoGeocodeErrorAlert:
          default_locations[countrycode] &&
          typeof default_locations[countrycode] != "undefined"
            ? default_locations[countrycode].translation.auto_geocode_error
            : default_locationsgb.translation.auto_geocode_error,
        distanceErrorAlert:
          default_locations[countrycode] &&
          typeof default_locations[countrycode] != "undefined"
            ? default_locations[countrycode].translation.distance_error
            : default_locations.gb.translation.distance_error,
        kilometerLang:
          default_locations[countrycode] &&
          typeof default_locations[countrycode] != "undefined"
            ? default_locations[countrycode].translation.kilometer
            : default_locations.gb.translation.kilometer,
        kilometersLang:
          default_locations[countrycode] &&
          typeof default_locations[countrycode] != "undefined"
            ? default_locations[countrycode].translation.kilometers
            : default_locations.gb.translation.kilometers,
        mileLang:
          default_locations[countrycode] &&
          typeof default_locations[countrycode] != "undefined"
            ? default_locations[countrycode].translation.mile
            : default_locations.gb.translation.mile,
        milesLang:
          default_locations[countrycode] &&
          typeof default_locations[countrycode] != "undefined"
            ? default_locations[countrycode].translation.miles
            : default_locations.gb.translation.miles,
        noResultsTitle:
          default_locations[countrycode] &&
          typeof default_locations[countrycode] != "undefined"
            ? default_locations[countrycode].translation.no_result_title
            : default_locations.gb.translation.no_result_title,
        noResultsDesc:
          default_locations[countrycode] &&
          typeof default_locations[countrycode] != "undefined"
            ? default_locations[countrycode].translation.no_results_desc
            : default_locations.gb.translation.no_results_desc,
        infowindowTemplatePath:
          scBaseURL + "templates/store-locator/dealer-info-window.html",
        listTemplatePath:
          scBaseURL + "templates/store-locator/dealer-list.html",
        addressID: "dealer-search",
        formContainer: "dealer-form-container",
        formID: "dealer-search-form",
        locationList: "dealer-list",
        mapID: "dealer-map",
        mapSettings: {
          zoom: 5,
        },
        callbackNotify: function (e) {
          console.warn(e);
          $("#dealer-search-form")
            .find(".dealer-search-error-alt")
            .html(e)
            .removeClass("sc-hidden");
        },
        callbackCreateMarker: function (map, point, letter, category) {
          return new google.maps.Marker({
            position: point,
            map: map,
            animation: google.maps.Animation.DROP,
            draggable: false,
          });
        },
        callbackSuccess: function (mappingObject, originPoint, data, page) {
          var location;
          var types = [];
          $("#dealer-search-form")
            .find(".dealer-search-error-alt")
            .html("")
            .removeClass("sc-hidden")
            .addClass("sc-hidden");

          if (
            mappingObject &&
            typeof mappingObject.geocodeResult != "undefined"
          ) {
            location = mappingObject.geocodeResult.geometry.location;
            types = mappingObject.geocodeResult.types;
          }

          var type = types ? types[0] : "COUNTRY";
          zoom_level = "";

          if (location && typeof location != "undefined") {
            default_lat = location.lat();
            default_lng = location.lng();
          }

          if (type) {
            switch (type.toUpperCase()) {
              case "COUNTRY":
                zoom_level = 5;
                break;
              case "LOCALITY":
                zoom_level = 10;
                break;
              case "ADMINISTRATIVE_AREA_LEVEL_1":
              case "COLLOQUIAL_AREA":
                zoom_level = 8; //7
                break;
              default:
                zoom_level = 14;
            }
          }
        },
        callbackMapSet: function (map, originPoint, originalZoom, myOptions) {
          google.maps.event.addListenerOnce(
            map,
            "bounds_changed",
            function (event) {
              if (
                zoom_level &&
                typeof zoom_level !== "undefined" &&
                this.getZoom()
              ) {
                this.setZoom(zoom_level); // set zoom
              }
            },
          );

          if (default_lat && default_lat) {
            var defaultpos = new google.maps.LatLng(default_lat, default_lng);
            var marker_icon = "../images/sc_marker.png";

            var default_marker = new google.maps.Marker({
              position: defaultpos,
              map: map,
              icon: marker_icon,
            });
          }
        },
      };

      $("#dealer-map").storeLocator(map_data);
    });
  },
  loadVideo: function (v) {
    var videos = document.getElementsByClassName("media-wrapper play-video");

    if (videos.length == 0) {
      videos = document.getElementsByClassName("lang-video-wrapper play-video");
    }

    if (v && videos.length) {
      for (var i = 0; i < videos.length; i++) {
        var el = videos[i];
        var data_video = el.getAttribute("data-video");

        if (
          data_video &&
          data_video != null &&
          data_video.toLowerCase() == v.toLowerCase()
        ) {
          var videl = el.getElementsByTagName("iframe")[0];

          if (typeof videl == "undefined" || videl.length == 0) {
            videl = el.getElementsByTagName("video source")[0];
          }

          sc_methods.removeLazyLoad(videl);

          $(el).trigger("click");
        } else if (i == videos.length - 1) {
          sc_methods.scrollToVideo();
        }
      }
    } else {
      sc_methods.scrollToVideo();
    }
  },
  scrollToVideo: function () {
    var videos = document.getElementsByClassName("media-wrapper play-video");

    if (videos.length == 0) {
      videos = document.getElementsByClassName("lang-video-wrapper play-video");
    }

    if (videos.length) {
      jQuery("html, body").animate(
        {
          scrollTop: $(videos[0]).offset().top - 150,
        },
        2000,
      );
      return false;
    }
  },
  getJsonFile: function (url, data, callback) {
    jQuery.getJSON(url + "?" + rev).done(function (data) {
      callback(JSON.stringify(data));
    });
  },
  showHideSubmenuButton: function (el) {
    var ow = el.offsetWidth;
    var sl = el.scrollLeft;
    var sw = el.scrollWidth;

    if (sw <= $(window).width()) {
      $(".sc-left-arrow").hide();
      $(".sc-right-arrow").hide();
    } else {
      if (sw > $(window).width()) {
        $(".sc-right-arrow").show();
      }

      if (sl == 0) {
        $(".sc-left-arrow").hide();
      } else if (ow + sl == sw) {
        $(".sc-right-arrow").hide();
      } else {
        $(".sc-left-arrow").show();
        $(".sc-right-arrow").show();
      }
    }
  },
  validateEmail: function (email) {
    var rgx =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return rgx.test(String(email).toLowerCase());
  },
  sendMail: function (params) {
    /* token key and url value is set in layout/partials/footer.html */
    var url = tokenurl ? tokenurl : ""; //"https://webservices-dev.scicanapi.com/emails/users/products/onlineaccess/token/notification/";
    var msg = messages
      ? messages.mailFailureMsg
      : "Unable to send e-mail. Please try again later.";
    var key = tokenkey ? tokenkey : "";
    $(".status-msg").html("").addClass("sc-hidden");

    params = JSON.stringify(params);

    if (location.hostname.indexOf("developer") > -1) {
      url =
        "https://webservices-qa.scicanapi.com/emails/users/products/onlineaccess/token/notification/";
      key = "4da36eb6tf4c2t4b32ta488t9eb76bc009f1";
    } else if (
      location.hostname.indexOf("developer") > -1 ||
      location.hostname.indexOf("hugo") > -1
    ) {
      url =
        "https://webservices-dev.scicanapi.com/emails/users/products/onlineaccess/token/notification/";
      key = "9ca9a917f0062f4d1af9ba2f599e999539b7";
    }

    $.ajax({
      method: "POST",
      url: url,
      data: params,
      headers: {
        "x-api-key": key,
        "Content-Type": "application/json",
      },
    })
      .done(function (data, status) {
        var d = {};

        try {
          if (data && typeof data == "object") {
            d = data;
          } else if (data && typeof data == "string") {
            d = $.parseJSON(data);
          }

          if (d.success) {
            msg = messages ? messages.mailSuccessMsg : "E-mail sent";
          }

          $(".status-msg").html(msg).removeClass("sc-hidden");
        } catch (e) {
          $(".status-msg").html(msg).removeClass("sc-hidden");

          if (console && console.error) {
            console.error(e);
          }
        }
      })
      .fail(function (jqXHR, textStatus, errorThrown) {
        $(".status-msg").html(msg).removeClass("sc-hidden");
      });
  },
  toTitleCase: function (str) {
    newstr = "";
    if (str.length > 0 && typeof str == "string") {
      newstr = str
        .split(" ")
        .map(function (st) {
          return st[0].toUpperCase() + st.substr(1);
        })
        .join(" ");
    }

    return newstr;
  },
};

jQuery("#menu-main-navigation > .menu-item-has-children").on(
  "keypress",
  function (e) {
    if (e.which !== ENTER_KEYCODE) {
      return;
    }

    $(this).addClass("menu-item-hovered");

    $(this).find("ul.sub-menu").focus();
  },
);

$(document).ready(function () {
  $("#menu-main-navigation > .menu-item-has-children").on(
    "focusout",
    function (e) {
      var $container = $(this);
      setTimeout(function () {
        if (!$container.has(document.activeElement).length) {
          $container.removeClass("menu-item-hovered");
        }
      }, 0);
    },
  );
});

//load video on scroll
// $(function () {
//   var $hero = $('[data-hero-video="true"]');
//   if (!$hero.length) return;
//   var $video = $hero.find('.statim-hero-video');
//   if (!$video.length) return;
//   var video = $video.get(0);

//   video.muted = true;
//   video.setAttribute('muted', '');
//   video.playsInline = true;
//   video.setAttribute('playsinline', '');

//   function pickSrc() {
//     var isMobile = window.matchMedia && window.matchMedia('(max-width: 768px)').matches;
//     return isMobile ? $video.data('mobile-src') : $video.data('desktop-src');
//   }

//   function setSrcIfNeeded() {
//     var src = pickSrc();
//     if (!src) return;

//     if (video.getAttribute('src') !== src) {
//       video.setAttribute('src', src);
//       video.load();
//     }
//   }

//   function heroInView() {
//     var top = $hero.offset().top;
//     var bottom = top + $hero.outerHeight();
//     var vTop = $(window).scrollTop();
//     var vBottom = vTop + $(window).height();
//     return bottom > vTop + 50 && top < vBottom - 50;
//   }

//   var started = false;
//   var timer = null;
//   var delayMs = 1200;
//   function tryPlay() {
//     if (started) return;
//     if (!heroInView()) return;
//     started = true;
//     setSrcIfNeeded();
//     var p = video.play();
//     if (p && typeof p.catch === 'function') {
//       p.catch(function () {
//         started = false;
//       });
//     }
//   }

//   $(window).one('scroll wheel touchmove', function () {
//     clearTimeout(timer);
//     timer = setTimeout(tryPlay, delayMs);
//   });

//   var rt = null;
//   $(window).on('resize', function () {
//     clearTimeout(rt);
//     rt = setTimeout(function () {
//       started = false;
//       setSrcIfNeeded();
//       tryPlay();
//     }, 150);
//   });
// });
